import React from 'react';

const Footer = () => {
  return (
    <div className="footer-info-fixed">
      © {new Date().getFullYear()} Vilano Consulting LLC
    </div>
  );
};

export default Footer;